<template>
  <div v-if="checking" role="status" class="q-pa-md">{{ $t('Loading') }}</div>
  <div v-else-if="aliasAvailable" class="terminal-min-height q-pa-md">
    <portal to="header"><terminal-header :title="$t('Link location labels')" raw-label-mode
      :out-focused="true" @barcode="handleBarcode" /></portal>
    <h5 class="q-my-sm">{{ $t('Map existing warehouse labels') }}</h5>
    <q-select v-model="warehouse" :options="warehouses" option-label="name" option-value="id" emit-value map-options
      use-input :label="$t('Warehouse')" @filter="filterWarehouses" />
    <p v-if="!warehouse">{{ $t('Choose the warehouse before scanning a location.') }}</p>
    <location-mapping v-else :key="warehouse" ref="mapping" :warehouse-id="warehouse" />
    <div v-if="error" role="alert" class="text-negative">{{ error }}</div>
  </div>
  <place-linking-legacy v-else />
</template>
<script>
import PlaceLinkingLegacy from './PlaceLinkingLegacy.vue';
import LocationMapping from '../../../shared/LocationMapping.vue';
export default {
  components: { LocationMapping, PlaceLinkingLegacy },
  data() { return { checking: true, aliasAvailable: false, warehouse: null, warehouses: [], error: '', generation: 0 }; },
  async mounted() {
    const generation = this.generation;
    try {
      const service = this.$service.storagePlace;
      const capability = service.identifierCapabilities ? await service.identifierCapabilities() : {};
      if (generation === this.generation) this.aliasAvailable = capability.locationAliases === true;
    } catch { this.aliasAvailable = false; }
    finally { if (generation === this.generation) this.checking = false; }
  },
  beforeUnmount() { this.generation += 1; },
  watch: { warehouse() { this.error = ''; } },
  methods: {
    async filterWarehouses(value, update) {
      try { const data = await this.$service.warehouse.getAll({ search: value, per_page: 50 }); update(() => { this.warehouses = data.items || []; }); }
      catch (error) { this.error = error.message; }
    },
    handleBarcode(barcode) {
      if (!this.warehouse) { this.error = this.$t('Choose the warehouse before scanning a location.'); return; }
      if (this.$refs.mapping) this.$refs.mapping.handleBarcode(barcode);

    },
  },
};
</script>
